import { v4 as uuidv4 } from "uuid";
import { Message as IMessage } from "./message";

export interface LeadOffsets {
    [key: number]: number;
}

export class Consumer {
    id: number = -1;
    logUid: string;
    interval: number = 1;
    commitOffsetStep: number = 1;
    offsets: LeadOffsets = {};
    leads: number[] = [];
    group: string = "0";
    recentMessage: IMessage | null = null;

    constructor() {
        this.logUid = uuidv4();
    }
}
